import StepOneComponent from './one.component'

export default StepOneComponent;
